export default __webpack_public_path__ + "static/media/me.cd3656ad.svg";